// dom selection
const allSection = document.querySelectorAll(".section");

const isInViewport = (el) => {
  const rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.top <= window.innerHeight;
};

const run = () =>
  allSection.forEach((sec) => {
    if (isInViewport(sec)) {
      sec.classList.remove("hidden");
    }
  });

// Events
window.addEventListener("load", run);
window.addEventListener("resize", run);
window.addEventListener("scroll", run);
//revel section
